export default {
  props: {
    transitionShow: {
      type: String,
      default: 'fadeIn',
    },
    transitionHide: {
      type: String,
      default: 'fadeOut',
    },
    transitionDuration: {
      type: [String, Number],
      default: 300, // ms
    },
  },
  computed: {
    transitionStyle() {
      const isNumber = (typeof this.transitionDuration === 'number');
      const duration = isNumber ? `${this.transitionDuration}ms` : this.transitionDuration;

      return {
        '--animate-duration': duration,
      };
    },
    enterActiveClass() {
      return `animated ${this.transitionShow}`;
    },
    leaveActiveClass() {
      return `animated ${this.transitionHide}`;
    },
  },
};
